export default function TableHeaderArrowDownIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M9.75 12V3H8.25V12H6L9 15L12 12H9.75Z" fill="currentColor" />
    </svg>
  );
}
